import { createStore as _createStore, useStore as _useStore, StoreProvider as _StoreProvider } from 'libs/store'
import { themeStore } from 'stores/theme'
// eslint-disable-next-line import/no-cycle
import { authStore } from 'stores/auth'
import { useApiCall } from 'api/apiHook'
// eslint-disable-next-line import/no-cycle
import { userStore } from 'stores/user'
// eslint-disable-next-line import/no-cycle
import { companyStore } from 'stores/company'
// eslint-disable-next-line import/no-cycle
import { newsStore } from 'stores/news'


export const useStore = (storeId) => {
  const { requestGraphQL, requestGraphQLFiles } = useApiCall()
  // Define plugins
  const store = _useStore(storeId, {
    requestGraphQL,
    requestGraphQLFiles,
  })
  return store
}
export const StoreProvider = _StoreProvider

/** @type {string} */
export const themeStoreId = 'theme'
export const authStoreId = 'auth'
export const userStoreId = 'user'
export const companyStoreId = 'company'
export const newStoreId = 'news'

/**
 * Initize and create stores
 * 
 * @function 
 * */
export const initStores = () => {
  _createStore(themeStoreId, themeStore)
  _createStore(authStoreId, authStore)
  _createStore(userStoreId, userStore)
  _createStore(companyStoreId, companyStore)
  _createStore(newStoreId, newsStore)
}